import { locale } from 'bv-i18n';

export const formatDate = (date) => new Date(date).toLocaleDateString(locale(), {
  weekday: 'long',
  day: 'numeric',
  month: 'short',
  hour: '2-digit',
  minute: '2-digit',
});
